module.exports = __webpack_public_path__ + "static/media/icon_system_rituals_social_pinterest.7565cd85.svg";